import useApi from '../hooks/useApi';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useMaintenanceService = () => {
  const { request } = useApi();

  const getMaintenanceStatus = async () => {
    try {
      const response = await request(`${BACKEND_URL}/auth/maintenance`, {}, 'GET');
      // Ensure we always return a valid object structure
      if (response && typeof response === 'object') {
        return {
          isEnabled: response.isEnabled || false,
          message: response.message || 'System is operational'
        };
      }
      return { isEnabled: false, message: 'System is operational' };
    } catch (error) {
      console.error('Error fetching maintenance status:', error);
      return { isEnabled: false, message: 'System is operational' };
    }
  };

  const updateMaintenanceMode = async (isEnabled, message = null) => {
    try {
      const payload = { isEnabled };
      if (message) {
        payload.message = message;
      }
      
      const response = await request(`${BACKEND_URL}/auth/maintenance`, {}, 'PUT', payload);
      return response;
    } catch (error) {
      console.error('Error updating maintenance mode:', error);
    }
  };

  return {
    getMaintenanceStatus,
    updateMaintenanceMode
  };
}; 